(function () {
    const body = document.body;
    function checkScroll() {
        if (window.scrollY > 30) {
            body.classList.add('scrolled');
        } else {
            body.classList.remove('scrolled');
        }
    }
    checkScroll();
    window.addEventListener('scroll', checkScroll);

    // Cycle through logo variants in a fixed order, advancing on each page load.
    // Nav and footer share the same counter but read from offset positions so they
    // always land on different variants.
    const logoVariants = [1, 2, 3, 4, 5];
    const footerOffset = 2;
    let logoIndex = 0;
    try {
        logoIndex =
            (parseInt(localStorage.getItem('logoVariantIndex'), 10) || 0) % logoVariants.length;
        localStorage.setItem('logoVariantIndex', String(logoIndex + 1));
    } catch {
        // localStorage unavailable (private mode etc.) — fall back to first variant
    }
    const navVariant = logoVariants[logoIndex];
    const footerVariant = logoVariants[(logoIndex + footerOffset) % logoVariants.length];
    document.querySelectorAll('.logo:not(.logo-footer):not(.no-random)').forEach(function (el) {
        el.classList.add('logo-variant-' + navVariant);
    });
    document.querySelectorAll('.logo.logo-footer:not(.no-random)').forEach(function (el) {
        el.classList.add('logo-variant-' + footerVariant);
    });

    document.querySelectorAll('.author-profile-website').forEach(function (el) {
        el.textContent = el.textContent.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '');
    });

    // Pick black or white text against any element's computed background
    // by WCAG contrast ratio. Returns null for transparent backgrounds.
    function relativeLuminance(r, g, b) {
        function channel(c) {
            c /= 255;
            return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
        }
        return 0.2126 * channel(r) + 0.7152 * channel(g) + 0.0722 * channel(b);
    }
    function pickAccessibleTextColor(el) {
        var bg = window.getComputedStyle(el).backgroundColor;
        var match = bg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?/);
        if (!match) return null;
        if (match[4] !== undefined && parseFloat(match[4]) === 0) return null;
        var bgLum = relativeLuminance(+match[1], +match[2], +match[3]);
        var whiteContrast = 1.05 / (bgLum + 0.05);
        var blackContrast = (bgLum + 0.05) / 0.05;
        return blackContrast > whiteContrast ? 'black' : 'white';
    }

    // Tag elements (topic-tag on /topics/ + homepage strip, post-card-tag on
    // post cards, nav-tag links in the header) paint a tag-specific background.
    document
        .querySelectorAll('.topic-tag, .post-card-tag, .gh-head-menu ul.nav li a')
        .forEach(function (el) {
            var color = pickAccessibleTextColor(el);
            if (color) el.style.color = color;
        });

    // Tag pages set --color-background to the tag's accent_color (default.hbs).
    // Flip --color-text and --color-link to match for legibility on any accent.
    if (document.body.classList.contains('tag-template')) {
        var bodyColor = pickAccessibleTextColor(document.body);
        if (bodyColor) {
            document.body.style.setProperty('--color-text', bodyColor);
            document.body.style.setProperty('--color-link', bodyColor);
        }
    }

    // News-primary posts: editors keep typing the publish date as a bold
    // first paragraph out of newspaper habit. The byline already shows it,
    // so hide the duplicate when the typed date matches the published date.
    var newsBylineDate = document.querySelector('.byline-meta-date--news');
    var ghContent = document.querySelector('.gh-content');
    if (newsBylineDate && ghContent) {
        var iso = newsBylineDate.getAttribute('datetime');
        if (iso) {
            var publishedDate = new Date(iso + 'T00:00:00Z');
            var weekday = publishedDate.toLocaleDateString('en-US', {
                weekday: 'long',
                timeZone: 'UTC',
            });
            var month = publishedDate.toLocaleDateString('en-US', {
                month: 'long',
                timeZone: 'UTC',
            });
            var day = publishedDate.getUTCDate();
            // Match US ("Wednesday, May 6") and UK/European
            // ("Tuesday, 5 May") order, with optional ordinal + year.
            var monthDayUS = month + '\\s+' + day + '(?:st|nd|rd|th)?';
            var monthDayUK = day + '(?:st|nd|rd|th)?\\s+' + month;
            var manualDatePattern = new RegExp(
                '^\\s*' +
                    weekday +
                    ',?\\s+(?:' +
                    monthDayUS +
                    '|' +
                    monthDayUK +
                    ')(?:,?\\s+\\d{4})?\\s*\\.?\\s*$',
                'i',
            );
            var firstEl = ghContent.firstElementChild;
            if (firstEl && manualDatePattern.test(firstEl.textContent || '')) {
                // Remove rather than display:none so .gh-content's `* + *`
                // sibling-spacing rule doesn't leave a gap above the next
                // paragraph.
                firstEl.remove();
            } else if (firstEl && firstEl.tagName === 'P') {
                // Shift+return makes the date share a `<p>` with the body via `<br>`.
                // Only the paragraph's direct children are inspected; a `<br>`
                // nested inside another element is left alone.
                var leadingText = '';
                var leadingNodes = [];
                var children = firstEl.childNodes;
                for (var i = 0; i < children.length; i++) {
                    var node = children[i];
                    if (node.nodeName === 'BR') {
                        var normalized = leadingText.replace(/\u00a0/g, ' ').trim();
                        if (manualDatePattern.test(normalized)) {
                            var toRemove = leadingNodes.concat([node]);
                            for (var j = i + 1; j < children.length; j++) {
                                if (children[j].nodeName !== 'BR') break;
                                toRemove.push(children[j]);
                            }
                            // `children` is live; break so the index doesn't
                            // skid after `.remove()` shifts everything left.
                            toRemove.forEach(function (n) {
                                n.remove();
                            });
                        }
                        break;
                    }
                    leadingText += node.textContent || '';
                    leadingNodes.push(node);
                }
            }
        }
    }
})();

// Forward Escape into Sodo Search's iframe so its own close handler runs,
// then restore focus to the trigger on close.
(function () {
    var lastTrigger = null;
    var modalOpen = false;

    // Capture-phase so an upstream stopPropagation can't hide the trigger.
    // Enter/Space on a <button> dispatches click, covering keyboard activation.
    document.addEventListener(
        'click',
        function (e) {
            var btn = e.target.closest('[data-ghost-search]');
            if (btn) lastTrigger = btn;
        },
        true,
    );

    function findOpenIframe() {
        var root = document.getElementById('sodo-search-root');
        return root ? root.querySelector('iframe.gh-root-frame') : null;
    }

    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var frame = findOpenIframe();
        if (!frame) return;
        try {
            var doc = frame.contentDocument;
            if (!doc) return;
            // Sodo listens on `keyup` — not a typo. Use the iframe's
            // KeyboardEvent so `event.view` matches its window.
            var Ctor = frame.contentWindow.KeyboardEvent;
            doc.dispatchEvent(new Ctor('keyup', {key: 'Escape', bubbles: true}));
        } catch (_) {
            // Sodo uses srcDoc (same-origin) today; bail if that ever changes.
        }
    });

    function checkModalState() {
        var nowOpen = !!findOpenIframe();
        if (nowOpen === modalOpen) return;
        modalOpen = nowOpen;
        if (!nowOpen) {
            if (lastTrigger && lastTrigger.isConnected) lastTrigger.focus();
            lastTrigger = null;
        }
    }

    // Sync check in case Sodo bootstrapped before this script ran.
    checkModalState();
    new MutationObserver(checkModalState).observe(document.body, {
        childList: true,
        subtree: true,
    });
})();

// Join date isn't exposed to templates, so fetch it from the members API.
(function () {
    var sinceEl = document.querySelector('[data-member-since]');
    if (!sinceEl) return;

    fetch('/members/api/member/')
        .then(function (res) {
            return res.ok ? res.json() : null;
        })
        .then(function (member) {
            if (!member || !member.created_at) return;
            var joined = new Date(member.created_at);
            if (isNaN(joined)) return;
            sinceEl.textContent =
                ' since ' + joined.toLocaleDateString('en-US', {month: 'short', year: 'numeric'});
        })
        .catch(function () {
            // Eyebrow already reads "On the inside" — nothing to do.
        });
})();

// Newsletter ships every Friday, so derive the status from today's date.
// TODO: open a follow-up to use real send dates.
(function () {
    var nextEl = document.querySelector('[data-next-issue]');
    var lastEl = document.querySelector('[data-last-issue]');
    if (!nextEl && !lastEl) return;

    var dow = new Date().getDay(); // Sun=0, Fri=5, Sat=6
    var sinceFriday = (dow - 5 + 7) % 7;
    var untilFriday = (5 - dow + 7) % 7;

    if (lastEl) {
        var last = sinceFriday + ' Days Ago';
        if (sinceFriday === 0) last = 'Today';
        else if (sinceFriday === 1) last = 'Yesterday';
        lastEl.textContent = last;
    }
    if (nextEl) {
        // On Friday the next issue is a week out, so force "Next Friday".
        var next = 'This Friday';
        if (untilFriday === 0) next = 'Next Friday';
        else if (untilFriday === 1) next = 'Tomorrow';
        nextEl.textContent = next;
    }
})();

// Copy-link buttons → clipboard + "Copied" feedback (styled per component)
(function () {
    document
        .querySelectorAll('.article-share-copy, .signup-page-share-copy')
        .forEach(function (btn) {
            btn.addEventListener('click', function () {
                var url = btn.getAttribute('data-url') || window.location.href;
                navigator.clipboard.writeText(url).then(function () {
                    btn.classList.add('is-copied');
                    setTimeout(function () {
                        btn.classList.remove('is-copied');
                    }, 2000);
                });
            });
        });
})();

// Paywall progress strip. The body is gated server-side, so estimate "% read" from the teaser
// word count vs the full reading_time (Ghost reports it in full even when gated). One value
// drives the label + fill; computed once, not a live scrollbar.
(function () {
    var strip = document.querySelector('[data-paywall-progress]');
    if (!strip) return; // setting off, or not a gated post

    // Can't show an honest % → remove the strip (collapses to the plain gate) rather than
    // leave an empty bar.
    function bail() {
        strip.remove();
    }

    var label = strip.querySelector('[data-paywall-progress-label]');
    var fill = strip.querySelector('[data-paywall-progress-fill]');
    var ghContent = document.querySelector('.gh-content');
    if (!label || !fill || !ghContent) return bail();

    // reading_time prints as "N min read"; parseInt grabs N (full minutes, even when gated).
    var readingTime = parseInt(ghContent.getAttribute('data-reading-time'), 10) || 0;

    // Count words in the public teaser only — drop the gate + decoy from a clone first.
    var clone = ghContent.cloneNode(true);
    ['.gh-post-upgrade-cta', '.paywall-locked'].forEach(function (selector) {
        clone.querySelectorAll(selector).forEach(function (node) {
            node.remove();
        });
    });
    var teaser = (clone.textContent || '').trim();
    var teaserWords = teaser ? teaser.split(/\s+/).length : 0;

    // No honest % (whole article gated, or no reading_time) → drop the strip.
    if (readingTime <= 0 || teaserWords <= 0) return bail();

    // 275 = Ghost's own wpm for reading_time, so this inverts Ghost's number, not a guess.
    var percent = Math.round((teaserWords / (readingTime * 275)) * 100);
    if (percent < 1) percent = 1; // clamp to a sane range
    if (percent > 99) percent = 99;

    label.textContent = "You've read " + percent + '%';
    fill.style.width = percent + '%';
})();

// Signup analytics: any data-members-form with a data-form-id reports submit + success.
(function () {
    document.querySelectorAll('form[data-members-form][data-form-id]').forEach(function (form) {
        var formId = form.getAttribute('data-form-id');

        // GA4 is consent-gated; no-op until gtag exists.
        function track(event) {
            if (typeof window.gtag === 'function') {
                window.gtag('event', event, {form_id: formId});
            }
        }

        form.addEventListener('submit', function () {
            track('signup_submit');
        });

        // Fire on each flip into .success, so a resend counts again.
        var succeeded = false;
        var observer = new MutationObserver(function () {
            var isSuccess = form.classList.contains('success');
            if (isSuccess && !succeeded) track('signup_success');
            succeeded = isSuccess;
        });
        observer.observe(form, {attributes: true, attributeFilter: ['class']});
    });
})();

// Signup popup analytics: one delegated listener for every link that opens Portal signup.
document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-portal^="signup"], a[href*="#/portal/signup"]');
    if (!link || typeof window.gtag !== 'function') return;

    var placement =
        link.getAttribute('data-signup-placement') ||
        (link.closest('.gh-content') ? 'post-content' : 'other');
    window.gtag('event', 'signup_popup_click', {placement: placement});
});

// Paywall inline signup. Ghost's native handler does the magic-link POST + .success/.error
// toggling; this adds the masked email, resend/change, and impression/conversion analytics.
(function () {
    var form = document.querySelector('[data-paywall-signup]');
    if (!form) return;

    var input = form.querySelector('[data-members-email]');
    var emailOut = form.querySelector('[data-paywall-email]');
    var resend = form.querySelector('[data-paywall-resend]');
    var change = form.querySelector('[data-paywall-change]');

    // GA4 is consent-gated; no-op until gtag exists.
    function track(event) {
        if (typeof window.gtag === 'function') {
            window.gtag('event', event, {method: 'magic_link', paywall: 'email_trap'});
        }
    }

    // l•••@berlin.de — keep first char + domain.
    function mask(email) {
        var at = email.indexOf('@');
        if (at < 1) return email;
        return email.charAt(0) + '•••' + email.slice(at);
    }

    track('paywall_impression');

    // Stash the masked address before .success flips.
    form.addEventListener('submit', function () {
        if (input && emailOut) {
            var value = input.value.trim();
            if (value) emailOut.textContent = mask(value);
        }
    });

    // .success = link sent = conversion; fire once.
    var converted = false;
    var observer = new MutationObserver(function () {
        if (!converted && form.classList.contains('success')) {
            converted = true;
            track('paywall_conversion');
        }
    });
    observer.observe(form, {attributes: true, attributeFilter: ['class']});

    if (resend) {
        resend.addEventListener('click', function () {
            if (typeof form.requestSubmit === 'function') {
                form.requestSubmit();
            }
        });
    }

    if (change) {
        change.addEventListener('click', function () {
            converted = false;
            form.classList.remove('success', 'error');
            if (input) {
                input.value = '';
                input.focus();
            }
        });
    }
})();

// Portal overwrites [data-members-error] with raw server text; swap it for HEIST copy.
(function () {
    var DEFAULT_COPY = 'Something went wrong. Please try again in a moment.';
    // Portal collapses unrecognised errors (incl. Ghost's "Email is not valid") into this one.
    var GENERIC =
        /^(Failed to send magic link email|There was an error sending the email|A server error occurred)/i;
    // Stricter than type="email": Ghost's validator also wants a dot in the domain.
    var LOOKS_LIKE_EMAIL = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;

    function friendly(raw, email, fallback) {
        if (/too many|try again later/i.test(raw)) {
            var wait = raw.match(/\d+ (minute|hour|day)s?/i);
            return wait
                ? 'Too many tries in a row. Please wait ' + wait[0] + ' and try again.'
                : 'Too many tries in a row. Please wait a few minutes and try again.';
        }
        if (
            /email (is )?not valid|invalid email/i.test(raw) ||
            (GENERIC.test(raw) && email && !LOOKS_LIKE_EMAIL.test(email))
        ) {
            return "That email address doesn't look right. Please check it and try again.";
        }
        if (/email domain are currently restricted/i.test(raw)) {
            return "We can't accept that email domain. Please try a different address.";
        }
        if (/unable to verify your request/i.test(raw)) {
            return "We couldn't verify your request. Please try again.";
        }
        return fallback;
    }

    document
        .querySelectorAll('.signup-feedback--error [data-members-error]')
        .forEach(function (el) {
            var fallback = el.textContent.trim() || DEFAULT_COPY;
            var input =
                el.closest('form') && el.closest('form').querySelector('[data-members-email]');
            var written = '';

            // Portal writes the text before or after adding .error depending on the failure, so watch the span itself.
            new MutationObserver(function () {
                var raw = el.textContent.trim();
                // Portal empties the span on each submit, so that clears the invalid flag too.
                if (input && raw) input.setAttribute('aria-invalid', 'true');
                if (input && !raw) input.removeAttribute('aria-invalid');
                if (!raw || raw === written) return;
                written = friendly(raw, input ? input.value.trim() : '', fallback);
                el.textContent = written;
            }).observe(el, {childList: true, characterData: true, subtree: true});
        });
})();

// Resend for every signup form that includes partials/signup-inbox.hbs.
// Ghost drops .success while it resubmits, so .signup-resending keeps the success block up.
(function () {
    document.querySelectorAll('.signup-inbox').forEach(function (block) {
        var form = block.closest('form');
        if (!form) return;
        var input = form.querySelector('[data-members-email]');
        var resend = block.querySelector('[data-signup-resend]');
        var sent = block.querySelector('[data-signup-sent]');
        var shown = false;
        var timer;

        function resetResend() {
            clearTimeout(timer);
            if (resend) resend.removeAttribute('aria-disabled');
            if (sent) sent.hidden = true;
        }

        new MutationObserver(function () {
            var ok = form.classList.contains('success');
            var failed = form.classList.contains('error');
            if (form.classList.contains('signup-resending')) {
                if (!ok && !failed) return;
                form.classList.remove('signup-resending');
                resetResend();
                if (failed && input) input.focus();
                if (ok && sent) {
                    sent.hidden = false;
                    timer = setTimeout(resetResend, 5000);
                }
                return;
            }
            // The field hides on success, so keep focus from dropping to <body>.
            if (ok && !shown && form.contains(document.activeElement)) block.focus();
            shown = ok;
        }).observe(form, {attributes: true, attributeFilter: ['class']});

        if (resend && typeof form.requestSubmit === 'function') {
            // aria-disabled, not disabled, so keyboard focus stays on the button.
            resend.addEventListener('click', function () {
                if (form.classList.contains('signup-resending') || !form.checkValidity()) return;
                resetResend();
                resend.setAttribute('aria-disabled', 'true');
                form.classList.add('signup-resending');
                form.requestSubmit();
            });
        } else if (resend) {
            resend.hidden = true;
        }
    });
})();

/* Podcast: episode numbers from Podigee's "N-" slug prefix (mirrored into Ghost
   post URLs, see docs/podcast.md); no prefix = plain cards. */
(function () {
    var EP_PREFIX = /^(\d+)-/;

    function slugFromPath(path) {
        var parts = path.replace(/\/+$/, '').split('/');
        return parts[parts.length - 1] || '';
    }

    // Card and homepage-band numbers, zero-padded like the album art track list
    document
        .querySelectorAll('.podcast-ep-card-link, .podcast-band-ep-link')
        .forEach(function (link) {
            var match = slugFromPath(link.pathname).match(EP_PREFIX);
            var number = link.querySelector('.podcast-ep-number');
            if (match && number) {
                number.textContent = match[1].length < 2 ? '0' + match[1] : match[1];
            }
        });

    // Episode page: the flag becomes "Episode N", read from the post URL's slug
    // prefix — embed-independent, so it survives Podigee's script-style embeds
    var flag = document.querySelector('[data-podcast-episode-flag]');
    if (flag) {
        var episode = slugFromPath(window.location.pathname).match(EP_PREFIX);
        if (episode) {
            flag.textContent = 'Episode ' + episode[1];
            flag.hidden = false;
        }
    }
})();

// Pin posts detected via the #food-map-pin codeinjection JSON — Ghost's {{#has tag}} is unreliable for internal tags.
(function () {
    var addrEl = document.querySelector('[data-food-map-address]');
    if (!addrEl) return;
    var script = document.getElementById('food-map-pin');
    if (!script) return;
    var data;
    try {
        data = JSON.parse(script.textContent);
    } catch (e) {
        console.warn('[food-map] address byline: invalid JSON in #food-map-pin', e);
        return;
    }
    var addressText = addrEl.querySelector('[data-food-map-address-text]');
    var directions = addrEl.querySelector('[data-food-map-directions]');
    var mapCta = addrEl.querySelector('[data-food-map-cta]');
    if (addressText && data.address) addressText.textContent = data.address;
    // Same slug shape as food-map.js slugifyName so the map resolves the pin param.
    if (mapCta && data.name) {
        var pinSlug = String(data.name)
            .toLowerCase()
            .normalize('NFKD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
        if (pinSlug) mapCta.href = '/food/map/?pin=' + pinSlug;
    }
    if (directions && data.lat != null && data.lng != null) {
        directions.href =
            'https://www.google.com/maps/dir/?api=1&destination=' +
            encodeURIComponent(data.lat + ',' + data.lng);
    }
    // "View on map" still shows without an address.
    if (!data.address) {
        if (directions) directions.style.display = 'none';
        var bull = addrEl.querySelector('.article-byline-bull');
        if (bull) bull.style.display = 'none';
    }
    var byline = document.querySelector('[data-byline]');
    if (byline) byline.classList.add('article-byline--food-map');
    addrEl.removeAttribute('hidden');
})();

// Ghost hard-codes "jamie@example.com" as the Signup card placeholder; it's also the field's only accessible name.
(function () {
    document.querySelectorAll('.kg-signup-card-input').forEach(function (input) {
        input.placeholder = 'Your email address';
    });
})();
